import { ResourceKey } from "i18next";

export const Competitors: ResourceKey = {
    allCompetitorsTitle: "Vos principaux concurrents",
};